(function () {
  const STORAGE_KEY = 'sheetal_wishlist_v1';
  const DATA_STORAGE_KEY = 'sheetal_wishlist_data_v1';
  const LEGACY_KEY = 'sheetal_wishlist_items';

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const read = () => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.map(String).filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  };

  const readDataMap = () => {
    try {
      const raw = localStorage.getItem(DATA_STORAGE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  };

  const writeDataMap = (map) => {
    try {
      localStorage.setItem(DATA_STORAGE_KEY, JSON.stringify(map));
    } catch (e) {}
  };

  const write = (arr) => {
    try {
      const cleanArr = Array.from(new Set(arr.map(String).filter(Boolean)));
      localStorage.setItem(STORAGE_KEY, JSON.stringify(cleanArr));
      // Also maintain legacy IDs list for any third-party scripts
      const dataMap = readDataMap();
      const legacyIds = cleanArr.map((h) => dataMap[h]?.id || h).filter(Boolean);
      localStorage.setItem(LEGACY_KEY, JSON.stringify(legacyIds));
    } catch (e) {}
  };

  const esc = (s) => String(s || '').replace(/</g, '&lt;').replace(/>/g, '&gt;');

  const ui = {
    toast: null,
    toastText: null,
    toastClose: null,
    toastOpen: null,
    overlay: null,
    drawer: null,
    close: null,
    list: null,
    count: [],
  };

  let toastTimer = null;

  const isIn = (handleOrId) => {
    if (!handleOrId) return false;
    const str = String(handleOrId);
    const list = read();
    if (list.includes(str)) return true;
    const dataMap = readDataMap();
    if (dataMap[str]) {
      const it = dataMap[str];
      if (list.includes(it.handle) || list.includes(String(it.id))) return true;
    }
    return Object.values(dataMap).some(
      (item) => (String(item.id) === str || item.handle === str) && (list.includes(item.handle) || list.includes(String(item.id)))
    );
  };

  const animateCount = () => {
    if (!ui.count.length) return;
    ui.count.forEach((badge) => {
      badge.classList.remove('is-bump');
      void badge.offsetWidth;
      badge.classList.add('is-bump');
    });
    window.setTimeout(() => ui.count.forEach((badge) => badge.classList.remove('is-bump')), 360);
  };

  const animateButton = (btn) => {
    if (!btn) return;
    btn.classList.remove('is-burst', 'animate-pop');
    void btn.offsetWidth;
    btn.classList.add('is-burst', 'animate-pop');
    window.setTimeout(() => btn.classList.remove('is-burst', 'animate-pop'), 450);
  };

  const updateCount = (opts = {}) => {
    const c = read().length;
    ui.count = $$('[data-sheetal-wishlist-count]');
    if (!ui.count.length) return;
    ui.count.forEach((badge) => {
      badge.textContent = c > 99 ? '99+' : String(c);
      badge.classList.toggle('is-visible', c > 0);
      badge.style.display = c > 0 ? '' : 'none';
    });
    if (opts.bump && c > 0) animateCount();
  };

  const setToast = (msg) => {
    if (!ui.toast) {
      ui.toast = $('[data-sheetal-wishlist-toast]');
      ui.toastText = $('[data-sheetal-wishlist-toast-text]');
      ui.toastClose = $('[data-sheetal-wishlist-toast-close]');
    }
    if (!ui.toast) return;
    if (ui.toastText) ui.toastText.textContent = msg;
    ui.toast.classList.remove('is-success');
    void ui.toast.offsetWidth;
    ui.toast.classList.add('is-success');
    ui.toast.classList.add('is-open');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => {
      ui.toast.classList.remove('is-open');
      ui.toast.classList.remove('is-success');
    }, 3400);
  };

  const closeSideMenuIfOpen = () => {
    try {
      const headerDrawer = document.querySelector('header-drawer');
      if (headerDrawer) {
        const details = headerDrawer.querySelector('details');
        if (details && details.hasAttribute('open')) {
          if (typeof headerDrawer.closeMenuDrawer === 'function') {
            headerDrawer.closeMenuDrawer(new Event('wishlist-open'), details.querySelector('summary'));
          } else {
            details.removeAttribute('open');
            details.classList.remove('menu-opening', 'menu-closing');
            const summary = details.querySelector('summary');
            if (summary) summary.setAttribute('aria-expanded', 'false');
          }
        }
      }
      const header = document.querySelector('.section-header');
      if (header) header.classList.remove('menu-open');
      const headerWrapper = document.querySelector('.header-wrapper');
      if (headerWrapper) headerWrapper.classList.remove('is-mobile-menu-open');

      document.body.classList.remove(
        'mobile-menu-open',
        'overflow-hidden-tablet',
        'overflow-hidden-desktop',
        'overflow-hidden-mobile',
        'overflow-hidden',
        'drawer-menu-active'
      );
      document.documentElement.classList.remove('mobile-menu-open');
    } catch (e) {}
  };

  const open = () => {
    closeSideMenuIfOpen();
    if (ui.overlay) ui.overlay.classList.add('is-open');
    if (ui.drawer) ui.drawer.classList.add('is-open');
    document.body.classList.add('wishlist-open');
    render();
  };

  const close = () => {
    if (ui.overlay) ui.overlay.classList.remove('is-open');
    if (ui.drawer) ui.drawer.classList.remove('is-open');
    document.body.classList.remove('wishlist-open');
    closeSideMenuIfOpen();
  };

  // Helper to extract full metadata from a button or its card container
  const extractButtonData = (btn) => {
    if (!btn) return null;
    let handle = btn.getAttribute('data-handle') || '';
    let id = btn.getAttribute('data-wishlist-product-id') || btn.getAttribute('data-wishlist-id') || btn.getAttribute('data-id') || '';
    let title = btn.getAttribute('data-title') || '';
    let price = btn.getAttribute('data-price') || '';
    let image = btn.getAttribute('data-image') || '';
    let url = btn.getAttribute('data-url') || '';

    // If any data is missing, look at parent card
    const card = btn.closest('.card-wrapper, .card, [class*="product-card"], .grid__item, li');
    if (card) {
      if (!title) {
        const titleEl = card.querySelector('.card__heading a, .full-unstyled-link, .card-information h3, h3 a');
        title = titleEl ? titleEl.textContent.trim() : '';
      }
      if (!image) {
        const imgEl = card.querySelector('img');
        image = imgEl ? (imgEl.currentSrc || imgEl.src || '') : '';
      }
      if (!price) {
        const priceEl = card.querySelector('.price-item--sale, .price-item--regular, .price');
        price = priceEl ? priceEl.textContent.trim() : '';
      }
      if (!url) {
        const linkEl = card.querySelector('.card__heading a, a.full-unstyled-link, a[href*="/products/"]');
        url = linkEl ? linkEl.getAttribute('href') : '';
      }
      if (!handle && url) {
        const match = url.match(/\/products\/([^?#]+)/);
        if (match) handle = match[1];
      }
    }

    if (!url && handle) url = `/products/${handle}`;
    return { handle: handle || id, id: String(id || ''), title: title || handle || id, price, image, url };
  };

  // Upgrades any legacy numeric IDs in storage to actual product handles
  const autoHealStorage = () => {
    const list = read();
    const dataMap = readDataMap();
    let hasChanges = false;
    const updatedList = [];

    list.forEach((item) => {
      const isNumeric = /^\d+$/.test(item);
      if (isNumeric) {
        // If dataMap has the handle for this numeric ID
        if (dataMap[item] && dataMap[item].handle && !/^\d+$/.test(dataMap[item].handle)) {
          const correctHandle = dataMap[item].handle;
          if (!updatedList.includes(correctHandle)) {
            updatedList.push(correctHandle);
          }
          hasChanges = true;
          return;
        }

        // Try to find on active page
        const btn = document.querySelector(`[data-wishlist-product-id="${item}"], [data-id="${item}"]`);
        if (btn) {
          const data = extractButtonData(btn);
          if (data && data.handle && !/^\d+$/.test(data.handle)) {
            dataMap[data.handle] = data;
            dataMap[item] = data;
            if (!updatedList.includes(data.handle)) {
              updatedList.push(data.handle);
            }
            hasChanges = true;
            return;
          }
        }
      }

      if (!updatedList.includes(item)) {
        updatedList.push(item);
      }
    });

    if (hasChanges) {
      writeDataMap(dataMap);
      write(updatedList);
    }
  };

  const syncButtons = () => {
    autoHealStorage();
    const list = read();
    const dataMap = readDataMap();

    // Collect all handles and IDs that are confirmed to be in the wishlist
    const activeHandles = new Set();
    const activeIds = new Set();

    list.forEach((item) => {
      activeHandles.add(item);
      activeIds.add(item);
      if (dataMap[item]) {
        if (dataMap[item].handle) activeHandles.add(dataMap[item].handle);
        if (dataMap[item].id) activeIds.add(String(dataMap[item].id));
      }
    });

    $$('.js-sheetal-wishlist-toggle, .sc-card-wishlist, [data-wishlist-product-id], [data-wishlist-id]').forEach((btn) => {
      const h = btn.getAttribute('data-handle');
      const id = String(btn.getAttribute('data-wishlist-product-id') || btn.getAttribute('data-wishlist-id') || btn.getAttribute('data-id') || '');
      const active = (h && activeHandles.has(h)) || (id && activeIds.has(id));

      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');

      const svg = btn.querySelector('svg');
      if (svg) {
        if (active) {
          svg.setAttribute('fill', '#dc2626');
          svg.setAttribute('stroke', '#dc2626');
        } else {
          svg.setAttribute('fill', 'none');
          svg.setAttribute('stroke', 'currentColor');
        }
      }
    });
  };

  const fetchProductData = async (identifier) => {
    const isNumeric = /^\d+$/.test(identifier);
    if (!isNumeric) {
      try {
        const res = await fetch(`/products/${identifier}.js`, { headers: { Accept: 'application/json' } });
        if (res.ok) {
          const p = await res.json();
          return {
            handle: p.handle || identifier,
            id: String(p.id || ''),
            url: p.url || `/products/${p.handle || identifier}`,
            title: p.title || identifier,
            image: p.featured_image || (p.images && p.images[0] ? p.images[0] : ''),
            price: p.price ? `₹${(p.price / 100).toFixed(2).replace(/\.00$/, '')}` : '',
          };
        }
      } catch (e) {}
    }

    // Search suggest fallback for numeric ID
    try {
      const sRes = await fetch(`/search/suggest.json?q=${encodeURIComponent(identifier)}&resources[type]=product`);
      if (sRes.ok) {
        const sData = await sRes.json();
        const products = sData?.resources?.results?.products || [];
        if (products.length > 0) {
          const match = products.find((p) => String(p.id) === String(identifier) || p.handle === identifier) || products[0];
          return {
            handle: match.handle,
            id: String(match.id),
            url: match.url || `/products/${match.handle}`,
            title: match.title,
            image: match.image || match.featured_image?.url || '',
            price: match.price ? `₹${parseFloat(match.price).toFixed(2).replace(/\.00$/, '')}` : '',
          };
        }
      }
    } catch (e) {}

    return { handle: identifier, id: String(identifier), url: `/products/${identifier}`, title: identifier, image: '', price: '' };
  };

  const render = async () => {
    if (!ui.list) {
      ui.list = $('[data-sheetal-wishlist-list]');
    }
    if (!ui.list) return;

    autoHealStorage();
    const handles = read();

    if (handles.length === 0) {
      ui.list.innerHTML = `<div class="sheetal-wishlist-empty">Your wishlist is empty.</div>`;
      return;
    }

    const cachedData = readDataMap();

    const items = await Promise.all(
      handles.map(async (h) => {
        if (cachedData[h] && cachedData[h].title && cachedData[h].title !== h && cachedData[h].image) {
          return cachedData[h];
        }
        const fetched = await fetchProductData(h);
        if (fetched && fetched.handle) {
          cachedData[fetched.handle] = fetched;
          if (fetched.id) cachedData[String(fetched.id)] = fetched;
        }
        return fetched;
      })
    );

    writeDataMap(cachedData);

    const cleanedHandles = items.map((it) => it.handle || it.id).filter(Boolean);
    write(cleanedHandles);

    ui.list.innerHTML = items
      .map((it) => {
        const title = esc(it.title);
        const img = it.image
          ? `<img src="${it.image}" alt="${title}">`
          : `<div style="width:64px;height:76px;background:#f4f4f4;border-radius:12px"></div>`;
        const price = it.price ? `<div class="sheetal-wishlist-item-meta">${esc(it.price)}</div>` : `<div class="sheetal-wishlist-item-meta"></div>`;

        return `
          <div class="sheetal-wishlist-item" data-handle="${esc(it.handle)}">
            ${img}
            <div>
              <div class="sheetal-wishlist-item-title">${title}</div>
              ${price}
              <div class="sheetal-wishlist-item-actions">
                <a class="sheetal-wishlist-mini-btn is-secondary" href="${it.url}">View</a>
                <button class="sheetal-wishlist-mini-btn" type="button" data-wishlist-remove="${esc(it.handle)}">Remove</button>
              </div>
            </div>
          </div>
        `;
      })
      .join('');

    $$('[data-wishlist-remove]', ui.list).forEach((btn) => {
      btn.addEventListener('click', () => {
        const h = btn.getAttribute('data-wishlist-remove');
        const dataMap = readDataMap();
        const next = read().filter((x) => x !== h && String(dataMap[x]?.id) !== h);
        write(next);
        syncButtons();
        updateCount();
        render();
        setToast('Removed from your wishlist.');
        window.dispatchEvent(new CustomEvent('sheetal:wishlist:updated', { detail: { items: next, isAdded: false, handle: h } }));
      });
    });
  };

  const toggle = (btnOrHandle) => {
    let itemData = null;

    if (btnOrHandle instanceof HTMLElement) {
      itemData = extractButtonData(btnOrHandle);
    } else if (typeof btnOrHandle === 'string') {
      const btn = document.querySelector(`[data-handle="${btnOrHandle}"], [data-wishlist-product-id="${btnOrHandle}"]`);
      itemData = btn ? extractButtonData(btn) : { handle: btnOrHandle, id: btnOrHandle, title: btnOrHandle, price: '', image: '', url: `/products/${btnOrHandle}` };
    }

    if (!itemData || (!itemData.handle && !itemData.id)) return false;

    const handle = itemData.handle;
    const id = itemData.id;
    const key = handle || id;

    const now = read();
    const dataMap = readDataMap();

    // Check if item is already in wishlist
    const exists = now.includes(key) ||
      (handle && now.includes(handle)) ||
      (id && now.includes(String(id))) ||
      (handle && dataMap[handle] && now.includes(dataMap[handle].id)) ||
      (id && dataMap[id] && now.includes(dataMap[id].handle));

    let next;
    let isAdded = false;

    if (exists) {
      next = now.filter((h) => h !== key && h !== handle && h !== String(id) && h !== dataMap[handle]?.id && h !== dataMap[id]?.handle);
      isAdded = false;
    } else {
      const targetHandle = handle || key;
      next = [targetHandle, ...now.filter((h) => h !== targetHandle && h !== String(id))].slice(0, 50);
      isAdded = true;

      // Save item data
      dataMap[targetHandle] = itemData;
      if (id) dataMap[String(id)] = itemData;
      writeDataMap(dataMap);
    }

    write(next);
    syncButtons();
    updateCount({ bump: isAdded });

    if (btnOrHandle instanceof HTMLElement) {
      animateButton(btnOrHandle);
    }

    setToast(isAdded ? 'The product has been added to your wishlist.' : 'Removed from your wishlist.');
    window.dispatchEvent(new CustomEvent('sheetal:wishlist:updated', { detail: { items: next, isAdded, handle, productId: id } }));
    return isAdded;
  };

  const bind = () => {
    ui.toast = $('[data-sheetal-wishlist-toast]');
    ui.toastText = $('[data-sheetal-wishlist-toast-text]');
    ui.toastClose = $('[data-sheetal-wishlist-toast-close]');
    ui.toastOpen = $('[data-sheetal-wishlist-open]');
    ui.overlay = $('[data-sheetal-wishlist-overlay]');
    ui.drawer = $('[data-sheetal-wishlist-drawer]');
    ui.close = $('[data-sheetal-wishlist-close]');
    ui.list = $('[data-sheetal-wishlist-list]');
    ui.count = $$('[data-sheetal-wishlist-count]');

    if (ui.toastClose) ui.toastClose.addEventListener('click', () => ui.toast.classList.remove('is-open'));
    if (ui.toastOpen) ui.toastOpen.addEventListener('click', () => open());
    if (ui.overlay) ui.overlay.addEventListener('click', () => close());
    if (ui.close) ui.close.addEventListener('click', () => close());

    document.addEventListener('click', (e) => {
      const toggleBtn = e.target.closest('.js-sheetal-wishlist-toggle, .sc-card-wishlist, [data-wishlist-product-id], [data-wishlist-id]');
      if (toggleBtn) {
        e.preventDefault();
        e.stopPropagation();
        toggle(toggleBtn);
        return;
      }

      const openBtn = e.target.closest('.js-sheetal-wishlist-open, [data-sheetal-wishlist-open]');
      if (openBtn) {
        e.preventDefault();
        e.stopPropagation();
        open();
        return;
      }
    });

    // initialize
    syncButtons();
    updateCount();
  };

  window.SheetalWishlist = {
    open,
    close,
    render,
    toggle,
    syncButtons,
    updateUI: syncButtons,
    updateCount,
    getItems: read,
    has: isIn,
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();
